import React from 'react'
import IntroSections from '../IntroSections'
import RowInCart from './RowinCart'
import {useCartContext} from '../context/CartContext';
import FormatCurrency from "../Store/FormatCurrency";
import storeItems from "../data/StoreData.json";


const Checkout = () => {
const {CartItems} = useCartContext();  

const total =  FormatCurrency(
        CartItems.reduce((total, cartItem) => {
        const item = storeItems.find((i) => i.id === cartItem.id);
        return total + (item?.price || 0) * cartItem.quantity ;
        }, 0)
    )
const Coupon =  FormatCurrency(
        CartItems.reduce((total, cartItem) => {
        const item = storeItems.find((i) => i.id === cartItem.id);
        return (total) + (item?.price   || 0)  * (cartItem.quantity) ;
        }, 0)
    )     
    
  return (
      <>
      <IntroSections sectionName="Checkout" sectionLink="Checkout" />
          

          <div className='Checkout_Container'>
                        
<div className='container'>
    <section className="checkout">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6 p-5">
                    <h3>BILLING & SHIPPING ADDRESS</h3>
                    <form className="form" id='form'>
                        <select className="form-select mb-4" aria-label="Default select example">
                            <option defaultValue="1">Egypt</option>
                            <option defaultValue="2">Saudi Arabia</option>
                            <option defaultValue="3">Tunisia</option>
                            <option defaultValue="3">Somalia</option>
                            <option defaultValue="3">Algeria</option>
                            <option defaultValue="3">Morocco</option>
                            <option defaultValue="3">England</option>
                            <option defaultValue="3">Finland</option>
                            <option defaultValue="3">United Kingdom</option>
                            <option defaultValue="3">France</option>
                            <option defaultValue="3">Germany</option>
                            <option defaultValue="3">Italy</option>

                        </select>
                            <div className="mb-4">
                                <input type="text" className="form-control" required id="exampleInputEmail1" placeholder="First Name" aria-describedby="emailHelp"/>
                            </div>
                        <div className="mb-4">
                            <input type="text" className="form-control" required id="exampleInputEmail1" placeholder="Last Name" aria-describedby="emailHelp"/>
                        </div>
                        <div className="mb-4">
                            <input type="text" className="form-control" required id="exampleInputEmail1" placeholder="Company Name" aria-describedby="emailHelp"/>
                        </div>
                        <div className="mb-4">
                            <input type="text" className="form-control" required id="exampleInputEmail1" placeholder="Address" aria-describedby="emailHelp"/>
                        </div>

                        <div className="row mb-4">
                            <div className="col">
                                <input type="text" className="form-control" required placeholder="Apartment, suite, unit etc." aria-label="First name"/>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" required placeholder="Town / City" aria-label="Last name"/>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col">
                                <input type="text" className="form-control" required placeholder="State / County" aria-label="First name"/>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" required placeholder="Postcode / Zip" aria-label="Last name"/>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col">
                                <input type="email" className="form-control" required placeholder=" Email" aria-label="First name"/>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" required placeholder=" Phone" aria-label="Last name"/>
                            </div>
                        </div>

                        <button className="buy mb-4">Create an account</button>
                    
                </form>
</div>

        <form className="col-lg-6 col-md-6 p-5">
             <h3>PAYMENT METHOD</h3>
                <div className="mt-4">
                    <input type="text" required className="form-control" id="formGroupExampleInput" placeholder="Name on Card"/>
                </div>
                <select className="form-select mt-4" aria-label="Default select example">
                    <option defaultValue>Credit Card Type</option>
                    <option defaultValue="1">Cashback credit cards</option>
                    <option defaultValue="2">Travel credit cards</option>
                    <option defaultValue="3">Business credit cards</option>
                </select>
            
                <div className="mt-4">
                    <input type="text" required className="form-control" id="formGroupExampleInput" placeholder="Credit Card Number"/>
                </div>
                <div className="mt-4">
                    <input type="text" required className="form-control" id="formGroupExampleInput" placeholder="Card Verification Number"/>
                </div>
                <button className="buy mt-4">Place Order Now</button>
                          
        </form>


</div>              
</div>
</section>
  
                  <div className='container_row'>
                      
                      <table  className="table CartPage  table-bordered text-center mt-5">
        <thead className="bg-dark text-light">
            <tr>
            <td>Product</td>
            <td>Product name</td>
            <td>Price</td>
            <td>Quantity</td>
            <td>Total</td>
            <td>Remove</td>     
            </tr>
             </thead>
                 {
    CartItems.map((item) => {    
     return(                 
         <tbody key={item.id} >
            <RowInCart {...item}/>  
    </tbody>   
        )})
              }  
             


</table>
</div>
      
    <div className='row'>
        <div className='col-lg-6'>
           
        <div className='CART_SUBTOTAL mt-5 pt-3'>
                <h3>CART SUBTOTAL</h3>           
             <table className="table table-bordered ">
                <tbody>
                    <tr>
                        <td>Order Subtotal</td>
                        <td>{total}</td>
                    </tr>
                    <tr>
                        <td>Shipping</td>
                        <td>Free Shipping</td>
                    </tr>

                    <tr>
                        <td>Coupon</td>
                        <td>$0</td>
                    </tr>

                    <tr>
                        <td>Total</td>
                    <td>{Coupon}</td>
                    </tr>
                </tbody>
            </table>
            </div>                 
            
        </div>         

    </div>               






    </div>

            </div>
      
      </>
  )
}

export default Checkout